<template>
  <model-table
    :data="items"
    :noItemLabel="$t('compCarbonFormsTravelsTable.no-travel')"
    :module="module"
    :forceDisabled="forceDisabled"
    :disabled="isSubmitted"
    :singleUpdateDisabled="false"
    :bulkOpsDisabled="false"
    :withTags="authStore.isAuthenticated"
    @update="$emit('update')"
    @edit="(item) => $emit('edit', item)"
    @del="(items) => $emit('del', items)"
  >
    <b-table-column
      :custom-sort="sortDepartureCity"
      :label="$t('compCarbonFormsTravelsTable.field-1')"
      sortable
      centered
      v-slot="props"
    >
      <span v-if="props.row.isFromDatabase()">-</span>
      <span v-else
        >{{ props.row.getDepartureCity() }} ({{
          props.row.getDepartureCountry()
        }})</span
      >
    </b-table-column>
    <b-table-column
      :custom-sort="sortDestinationCity"
      :label="$t('compCarbonFormsTravelsTable.field-2')"
      sortable
      centered
      v-slot="props"
    >
      <span v-if="props.row.isFromDatabase()">-</span>
      <span v-else
        >{{ props.row.getDestinationCity() }} ({{
          props.row.getDestinationCountry()
        }})</span
      >
    </b-table-column>
    <b-table-column
      :custom-sort="sortTransportation"
      :label="$t('compCarbonFormsTravelsTable.field-3')"
      sortable
      centered
      v-slot="props"
    >
      <div style="white-space: nowrap">
        <b-icon
          v-for="(transportation, index) in props.row.sections.map(
            (obj) => obj.transportation
          )"
          :key="index"
          :pack="modePack(transportation)"
          :icon="modeIcon(transportation)"
        ></b-icon>
      </div>
    </b-table-column>
    <b-table-column
      :custom-sort="sortDistance"
      sortable
      :label="$t('compCarbonFormsTravelsTable.field-4')"
      numeric
      v-slot="props"
    >
      <span v-if="props.row.getDistance() !== null"
        >{{ Math.round(props.row.getDistance()) | splitNumber }} km</span
      >
      <span v-else>-</span>
    </b-table-column>
    <b-table-column
      field="amount"
      sortable
      :label="$t('compCarbonFormsTravelsTable.field-9')"
      numeric
      v-slot="props"
    >
      <span v-if="props.row.amount">
        {{ props.row.amount }}
      </span>
      <span v-else> - </span>
    </b-table-column>
    <b-table-column
      field="purpose"
      sortable
      :label="$t('compCarbonFormsTravelsTable.field-7')"
      centered
      v-slot="props"
    >
      <span v-if="props.row.purpose && props.row.purpose !== 'unknown'">
        {{ $t(props.row.purpose) }}
      </span>
      <span v-else> - </span>
    </b-table-column>
    <b-table-column
      field="status"
      :label="$t('compCarbonFormsTravelsTable.field-8')"
      sortable
      centered
      v-slot="props"
    >
      <span v-if="props.row.status && props.row.status !== 'unknown'">
        {{ $t(props.row.status) }}
      </span>
      <span v-else> - </span>
    </b-table-column>
  </model-table>
</template>

<script>
import { useAuthenticationStore } from '@/stores/authentication.js'
import Travel from '@/models/carbon/Travel.js'
import Modules from '@/models/Modules.js'
import { useGHGIStore } from '@/stores/ghgi.js'

export default {
  name: 'Table',
  setup () {
    const authStore = useAuthenticationStore()
    const ghgiStore = useGHGIStore()
    return { authStore, ghgiStore }
  },
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    'model-table': () => import('@/components/carbon/forms/ModelTable.vue')
  },
  computed: {
    module: function () {
      return Modules.TRAVELS
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    }
  },
  methods: {
    sortBool (a, b, isAsc) {
      if (isAsc) {
        return Number(a) - Number(b)
      } else {
        return Number(b) - Number(a)
      }
    },
    sortStr (a, b, isAsc) {
      if (a === null) {
        return 1
      }
      if (b === null) {
        return -1
      }
      if (isAsc) {
        return a.localeCompare(b)
      } else {
        return b.localeCompare(a)
      }
    },
    sortDepartureCity (a, b, isAsc) {
      return this.sortStr(a.getDepartureCity(), b.getDepartureCity(), isAsc)
    },
    sortDestinationCity (a, b, isAsc) {
      return this.sortStr(a.getDestinationCity(), b.getDestinationCity(), isAsc)
    },
    sortDistance (a, b, isAsc) {
      if (isAsc) {
        return a.getDistance() - b.getDistance()
      } else {
        return b.getDistance() - a.getDistance()
      }
    },
    sortTransportation (a, b, isAsc) {
      return this.sortStr(
        a.getMainTransportation(),
        b.getMainTransportation(),
        isAsc
      )
    },
    forceDisabled: function (row) {
      return row.isFromDatabase()
    },
    modeIcon: function (mode) {
      return Travel.getIcon(mode)
    },
    modePack: function (mode) {
      return Travel.getIconPack(mode)
    }
  }
}
</script>
